import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'
import clsx from 'clsx'

import type { GroupByOption } from '../types'

type Props<T> = {
  options: GroupByOption<T>[]
  activeKey: string
  onChange: (key: string) => void
}

const DualListTabs = <T,>({ options, activeKey, onChange }: Props<T>) => {
  return (
    <div css={S.tabs}>
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          css={S.tabItem}
          className={clsx(activeKey === option.key && 'active')}
          onClick={() => onChange(option.key)}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default DualListTabs

const S = {
  tabs: css`
    display: flex;
    padding: 4px;
    background-color: white;
    border: 1px solid var(--Colors-Gray-300);
    border-radius: var(--Radius-100);
  `,
  tabItem: css`
    display: flex;
    flex: 1 0 0;
    height: 32px;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    border: none;
    border-radius: var(--Radius-100);
    background-color: white;
    cursor: pointer;
    ${typo.caption01};
    color: var(--Colors-Gray-500);
    &.active {
      background-color: var(--Colors-Gray-200);
      color: var(--Colors-Gray-900);
      font-weight: 700;
    }
  `,
}
